import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import {
  ExpansionPanel,
  ExpansionPanelActionEvent,
  GridLayout,
  GridLayoutItem,
} from "@progress/kendo-react-layout";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import FormTextField from "../../components/formFields/FormTextField";
import RippleButton from "../../components/common/RippleButton";
import ButtonForAll from "../../components/common/ButtonForAll";
import IconComponent from "../../components/common/IconComponent";
import { FaFilter } from "react-icons/fa";
import { Button } from "@progress/kendo-react-buttons";

// import { useLocation } from "react-router-dom";
import {
  clearFlightQuotationFilterDetails,
  setFlightQuotationFilterDetails,
} from "./quotationSlice";
import FormDatePicker from "../../components/formFields/FormDateField";
import moment from "moment";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { IVendor } from "../vendor/vendorModel";
import { IFlightPlace } from "../flightplace/flightplaceModel";
import { IUser } from "../user/userModel";
import { TRIPTYPE } from "../../_contstants/common";

const FlightQuotationFilter: React.FC = () => {
  const gridRef = useRef<any>(null);
  const BTNRef = useRef<any>(null);

  const dispatch = useAppDispatch();
  // const location = useLocation();
  // const filterContactID = location.state?.ContactID;
  // const filterInquiryID = location.state?.InquiryID;
  // const filterLeadID = location.state?.LeadID;
  const loading = useAppSelector((state) => state.lead.loading);
  const [expand, setExpand] = useState("");
  const FlightQuotationFilterDetails = useAppSelector(
    (state) => state.quotation.FlightQuotationFilterDetails
  );
  const VendorList = useAppSelector((state) => state.vendor.VendorList);
  const FlightPlaceList = useAppSelector(
    (state) => state.flightplace.FlightPlaceList
  );
  const UserList = useAppSelector((state) => state.user.UserList);

  const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [FlightQuotationFilterDetails]);

  useEffect(() => {
    // const idMapping: Partial<
    //   Pick<
    //     IQuotationFilterDetails,
    //     "filterContactID" | "filterInquiryID" | "filterLeadID"
    //   >
    // > = { filterContactID, filterLeadID, filterInquiryID };

    // const updatedFilterDetails = Object.entries(idMapping).reduce(
    //   (acc, [key, value]) => {
    //     const typedKey = key as keyof IQuotationFilterDetails;

    //     return {
    //       ...acc,
    //       [typedKey]: FlightQuotationFilterDetails?.[typedKey]
    //         ? `${FlightQuotationFilterDetails[typedKey]}`
    //         : value
    //         ? `${value}`
    //         : "",
    //     };
    //   },
    //   {} as Partial<IQuotationFilterDetails>
    // );

    // if (
    //   Object.values(updatedFilterDetails).some((value) => value) &&
    //   JSON.stringify(updatedFilterDetails) !==
    //     JSON.stringify(QuotationFilterDetails)
    // ) {
    dispatch(
      setFlightQuotationFilterDetails({
        ...FlightQuotationFilterDetails,
        // ...updatedFilterDetails,
      })
    );
    // }
  }, []);

  const handleSubmit = async (values: any) => {
    const insertPayload = {
      // filterContactID:
      //   QuotationFilterDetails?.filterContactID || filterContactID || "",
      // filterLeadID: QuotationFilterDetails?.filterLeadID || filterLeadID || "",
      // filterInquiryID:
      //   QuotationFilterDetails?.filterInquiryID || filterInquiryID || "",

      filterVendorID: values?.filterVendorID ? +values?.filterVendorID : null,
      filterAirlineName: values?.filterAirlineName
        ? values?.filterAirlineName
        : "",
      filterFromAirportID: values?.filterFromAirportID
        ? +values?.filterFromAirportID
        : null,
      filterToAirportID: values?.filterToAirportID
        ? +values?.filterToAirportID
        : null,
      filterDepartureDate: values?.filterDepartureDate
        ? moment(values?.filterDepartureDate)?.format("YYYY-MM-DD")
        : "",
      filterArrivalDate: values?.filterArrivalDate
        ? moment(values?.filterArrivalDate)?.format("YYYY-MM-DD")
        : "",
      filterTripType: values?.filterTripType ? +values?.filterTripType : null,
      filterCreatedBy: values?.filterCreatedBy
        ? +values?.filterCreatedBy
        : null,
    };
    setExpand("");
    dispatch(setFlightQuotationFilterDetails(insertPayload));
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <Form
        key={formKey}
        onSubmit={handleSubmit}
        initialValues={{
          ...FlightQuotationFilterDetails,
          filterDepartureDate: FlightQuotationFilterDetails?.filterDepartureDate
            ? moment(
                FlightQuotationFilterDetails?.filterDepartureDate,
                "YYYY-MM-DD"
              )?.toDate()
            : "",
          filterArrivalDate: FlightQuotationFilterDetails?.filterArrivalDate
            ? moment(
                FlightQuotationFilterDetails?.filterArrivalDate,
                "YYYY-MM-DD"
              )?.toDate()
            : "",
        }}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <ExpansionPanel
              className="inquiry-filter-panel m-0"
              title={
                <div>
                  <div>
                    <IconComponent icon={FaFilter} /> Filter Results
                  </div>
                </div>
              }
              expanded={expand === "filter"}
              tabIndex={1}
              onAction={(event: ExpansionPanelActionEvent) => {
                const nativeEvent = event.nativeEvent as KeyboardEvent;
                const ActiveBTN = document.activeElement as HTMLElement;

                if (
                  nativeEvent.type === "keydown" &&
                  nativeEvent.code === "Space"
                ) {
                  nativeEvent.preventDefault();
                  return;
                } else if (
                  nativeEvent.code === "Enter" ||
                  nativeEvent.code === "NumpadEnter"
                ) {
                  nativeEvent.preventDefault();
                  if (ActiveBTN.id === "FlightQuotationSubmitBtn") {
                    BTNRef.current.element.click();
                  } else if (ActiveBTN.id === "ClearFlightQuotationDetail") {
                    setExpand("");
                  }
                  return;
                }

                if (event?.expanded) {
                  setExpand("");
                } else {
                  setExpand("filter");
                }
              }}
            >
              {expand === "filter" && (
                <GridLayout
                  style={{ marginRight: 20, padding: 10 }}
                  gap={{ rows: 0, cols: 10 }}
                  cols={[
                    { width: "33.33%" },
                    { width: "33.33%" },
                    { width: "33.33%" },
                  ]}
                >
                  <GridLayoutItem>
                    <Field
                      wrapperClassName="w-100"
                      id={"filterVendorID"}
                      name={"filterVendorID"}
                      label={"Vendor"}
                      placeholder="Vendor"
                      component={FormSelectionField}
                      options={VendorList?.map((vendor: IVendor) => {
                        return {
                          value: vendor?.ID,
                          label: vendor?.VendorName,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="filterAirlineName"
                      label="Airline Name"
                      placeholder="Airline Name"
                      maxLength="100"
                      component={FormTextField}
                      // onKeyDown={(e: any) => {
                      //   if (e.key === " ") {
                      //     formRenderProps.onChange("filterAirlineName", {
                      //       value: `${e?.target?.value} `,
                      //     });
                      //   }
                      // }}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      wrapperClassName="w-100"
                      id={"filterFromAirportID"}
                      name={"filterFromAirportID"}
                      label="From Airport"
                      component={FormSelectionField}
                      options={FlightPlaceList?.map(
                        (flightplace: IFlightPlace) => {
                          return {
                            value: flightplace?.ID,
                            label: flightplace?.FlightPlaceName,
                          };
                        }
                      )}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      wrapperClassName="w-100"
                      id={"filterToAirportID"}
                      name={"filterToAirportID"}
                      label="To Airport"
                      component={FormSelectionField}
                      options={FlightPlaceList?.map(
                        (flightplace: IFlightPlace) => {
                          return {
                            value: flightplace?.ID,
                            label: flightplace?.FlightPlaceName,
                          };
                        }
                      )}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      wrapperStyle={{ width: "100%" }}
                      name={"filterDepartureDate"}
                      label="Departure Date"
                      format="dd/MM/yyyy"
                      component={FormDatePicker}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      wrapperStyle={{ width: "100%" }}
                      name={"filterArrivalDate"}
                      label="Arrival Date"
                      format="dd/MM/yyyy"
                      minDate={moment(
                        formRenderProps.valueGetter("FromDate")
                      ).toDate()}
                      component={FormDatePicker}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      wrapperClassName="w-100"
                      id={"filterTripType"}
                      name={"filterTripType"}
                      label={"Trip Type"}
                      placeholder="Trip Type"
                      component={FormSelectionField}
                      options={TRIPTYPE?.map((tripType) => {
                        return {
                          value: tripType?.value,
                          label: tripType?.label,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      wrapperClassName="w-100"
                      id={"filterCreatedBy"}
                      name={"filterCreatedBy"}
                      label="Created By"
                      component={FormSelectionField}
                      options={UserList?.map((user: IUser) => {
                        return {
                          value: user?.ID,
                          label: `${user?.FirstName} ${user?.LastName}`,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem
                    // colSpan={3}
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      alignItems: "end",
                      marginTop: 20,
                    }}
                  >
                    <RippleButton
                      id={"ClearContactDetail"}
                      type="button"
                      fillMode="outline"
                      themeColor="error"
                      style={{ marginRight: 10 }}
                      onClick={(e: any) => {
                        e.stopPropagation();
                        dispatch(clearFlightQuotationFilterDetails());
                      }}
                    >
                      Clear
                    </RippleButton>
                    <ButtonForAll
                      id={"FlightQuotationSubmitBtn"}
                      label={"Filter"}
                      type="submit"
                      disabled={!formRenderProps.allowSubmit || loading}
                    />

                    <RippleButton
                      id={"ClearFlightQuotationDetail"}
                      type="button"
                      fillMode="outline"
                      themeColor="primary"
                      style={{ marginLeft: 10 }}
                      onClick={() => setExpand("")}
                    >
                      Cancel
                    </RippleButton>
                  </GridLayoutItem>
                </GridLayout>
              )}
            </ExpansionPanel>
            {
              <Button
                style={{ opacity: 0, position: "absolute", left: -50 }}
                ref={BTNRef}
                type="submit"
                disabled={!formRenderProps.allowSubmit || loading}
              >
                Filter
              </Button>
            }
          </FormElement>
        )}
      />
    </>
  );
};

export default FlightQuotationFilter;
